//React
import React from "react";

//UI
import { InputNumber as AntDInputNumber } from "antd";

//CSS
import "./styles/input.css";


const InputNumber = (props) => {
  return <AntDInputNumber className="custom-input" {...props} />;
};

export default InputNumber;
